// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `location-help {
  opacity: 0;
  animation: 200ms fade-in;
  animation-fill-mode: forwards;
  pointer-events: initial;
  display: flex;
  flex-direction: column;
  background-color: var(--dark-bg-color);
  width: 100%;
  height: 100%;
}
location-help h3 {
  margin-bottom: var(--small-spacing);
}
location-help .fading-image-bg .page-content {
  justify-content: flex-end;
}
location-help .page-header {
  flex-grow: 1;
}
location-help .chrome-gps-icon {
  width: auto;
}
location-help .instructions-container .instructions {
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: var(--medium-spacing);
  grid-row-gap: var(--large-spacing);
  margin-bottom: var(--large-spacing);
  align-items: center;
}
location-help .instructions-container .instructions .svg-icon {
  font-size: 40px;
  display: flex;
}
location-help .instructions-container .instructions p {
  margin: 0;
}
location-help .instructions-container button {
  margin: 0;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/location-help/location-help.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,wBAAA;EACA,6BAAA;EAEA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,sCAAA;EACA,WAAA;EACA,YAAA;AAAJ;AAEI;EACI,mCAAA;AAAR;AAGI;EACI,yBAAA;AADR;AAII;EACI,YAAA;AAFR;AAKI;EACI,WAAA;AAHR;AAOQ;EACI,aAAA;EACA,gCAAA;EACA,sCAAA;EACA,kCAAA;EACA,mCAAA;EACA,mBAAA;AALZ;AAQY;EACI,eAAA;EACA,aAAA;AANhB;AASY;EACI,SAAA;AAPhB;AAWQ;EACI,SAAA;AATZ;AAaI;EACI;IACI,UAAA;EAXV;EAaM;IACI,UAAA;EAXV;AACF","sourcesContent":["location-help {\n    opacity: 0;\n    animation: 200ms fade-in;\n    animation-fill-mode: forwards;\n\n    pointer-events: initial;\n    display: flex;\n    flex-direction: column;\n    background-color: var(--dark-bg-color);\n    width: 100%;\n    height: 100%;\n\n    h3 {\n        margin-bottom: var(--small-spacing);\n    }\n\n    .fading-image-bg .page-content {\n        justify-content: flex-end;\n    }\n\n    .page-header {\n        flex-grow: 1;\n    }\n\n    .chrome-gps-icon {\n        width: auto;\n    }\n\n    .instructions-container {\n        .instructions {\n            display: grid;\n            grid-template-columns: auto auto;\n            grid-column-gap: var(--medium-spacing);\n            grid-row-gap: var(--large-spacing);\n            margin-bottom: var(--large-spacing);\n            align-items: center;\n\n\n            .svg-icon {\n                font-size: 40px;\n                display: flex;\n            }\n\n            p {\n                margin: 0;\n            }\n        }\n\n        button {\n            margin: 0;\n        }\n    }\n\n    @keyframes fade-in {\n        0% {\n            opacity: 0;\n        }\n        100% {\n            opacity: 1;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
